import select from "./form/select.vue";
export default {
  "z-select": select,
};
